import institutionalLogoIHSA from "@/assets/logo-institucional-ihsa.webp";

interface LogoIHSAProps {
  width?: string | number;
  height?: string | number;
}

export const LogoIHSA = ({ width = 55, height = 25.297 }: LogoIHSAProps) => (
  <img
    src={institutionalLogoIHSA}
    alt="Logo IHSA"
    style={{ width, height, objectFit: "contain" }}
  />
);
